'use strict'; // load websocket library if we are not in the browser

var WebSocket = require('./web-socket');

var duplex = require('./duplex');

var wsurl = require('./ws-url');

module.exports = function (addr) {
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var location = typeof window === 'undefined' ? {} : window.location;
  var url = wsurl(addr, location);
  var socket = new WebSocket(url, opts.websocket);
  var stream = duplex(socket, opts);
  stream.remoteAddress = url;

  stream.close = function () {
    return new Promise(function (resolve, reject) {
      socket.addEventListener('close', resolve);
      socket.close();
    });
  };

  stream.destroy = function () {
    socket.terminate();
  };

  stream.socket = socket;
  return stream;
};

module.exports.connect = module.exports;